import { 
  CREATE_BRANDKIT_COLOR, UPDATE_BRANDKIT_COLOR_PROPERTY, DELETE_BRANDKIT_COLOR, RENAME_BRANDKIT_COLORS,
  FETCHING_BRANDKIT_COLORS_REQUEST, FETCHING_BRANDKIT_COLORS_SUCCEEDED, FETCHING_BRANDKIT_COLORS_FAILED,
  DELETE_BRANDKIT_COLORS_REQUEST, DELETING_BRANDKIT_COLORS_SUCCEEDED, DELETING_BRANDKIT_COLORS_FAILED,
  UPDATE_BRANDKIT_COLORS_REQUEST, UPDATING_BRANDKIT_COLORS_SUCCEEDED, UPDATING_BRANDKIT_COLORS_FAILED,
  INVALIDATE_BRANDKIT_COLORS,
} from "constants/actionTypes";
  
import _ from 'lodash';
  
  const initialState = {
    loading: false,
    updating: false,
    fetched: false,
    invalidated: false,
    errorType: null,
    items: [],
    components: [],
    invalidated: false
  }

  
  export function brandKitColorsReducer(state = initialState, action) {
    switch (action.type) {

      case CREATE_BRANDKIT_COLOR: {
        var { component } = action.payload;

        const existingComponents = [...state.components];

        if (existingComponents.length != 0) {
          component = {
            ...component,
            order: existingComponents.length + 1,
            changes: true
          }
        }

        var updatedState = {
          ...state,
          components: [...existingComponents, component],
        }

        return updatedState;
      }

      case DELETE_BRANDKIT_COLOR: {
        const { ids } = action.payload;

        const updatedComponents = state.components.filter(component => !ids.includes(component.id));

        return {
          ...state,
          components: updatedComponents
        }

      }

      case UPDATE_BRANDKIT_COLOR_PROPERTY: {
        const { id, property } = action.payload;
      
        const components = state.components || [];
        
        const updatedComponents = components.map(component => {
          if (component.id === id) {
      
            return {
              ...component,
              changes:true,
              draft: {
                ...component.draft,
                content: property,
              },
            };
          }
          return component;
        });
      
        return {
          ...state,
          components: updatedComponents,
        };
      }

      case RENAME_BRANDKIT_COLORS: {
        const { id, name } = action.payload;

        const components = state.components || [];

        const updatedComponents = components.map(component => {
          if (component.id === id) {
      
            return {
              ...component,
              changes: true,
              name: name
            };
          }
          return component;
        });
      
        return {
          ...state,
          components: updatedComponents,
        };
      }
  
      case FETCHING_BRANDKIT_COLORS_REQUEST: {
        return {
          ...state,
          loading: true
        }
      }
      
      case FETCHING_BRANDKIT_COLORS_SUCCEEDED: {
        return {
          ...state,
          loading: false,
          items: action.payload,
          components: action.payload.components
        }
      }
  
      case FETCHING_BRANDKIT_COLORS_FAILED: {
        return {
          ...state,
          loading: false,
          error: action.payload
        }
      }
  
      case DELETE_BRANDKIT_COLORS_REQUEST: {

        return {
            ...state,
            deleting: true,
          }
      }
  
      case DELETING_BRANDKIT_COLORS_SUCCEEDED: {
        const { ids, response } = action.payload;

        const components = state.components.filter(item => (!(ids).includes(item.id)));
  
        return {
          ...state,
          loading: false,
          deleting: false,
          components: components,        }
      }
  
      case DELETING_BRANDKIT_COLORS_FAILED: {
        return {
          ...state,
          loading: false,
          error: action.payload.error[0]
        }
      }
  
      case UPDATE_BRANDKIT_COLORS_REQUEST: {
        return {
          ...state,
          loading: true,
          updating: true
        }
      }
        
      case UPDATING_BRANDKIT_COLORS_SUCCEEDED: { 
        const {response} = action.payload;

        return {
          ...state,
          loading: false,
          updating: false,
          updated: true,
          items: response,
          components: response.components
        }
      }
        
      case UPDATING_BRANDKIT_COLORS_FAILED: {
        return {
          ...state,
          updating: false,
          loading: false,
          error: action.payload.error[0]
        }
      }

      case INVALIDATE_BRANDKIT_COLORS: {
        return {
          ...state,
          loading: false,
          updating: false,
          updated: false,
          fetched: false,
          invalidated: false,
          errorType: null,
          invalidated: false
        }
      }
         
      default:
        return state;
    }
  }
  
  